import {
    Grid2,
    Typography,
    Box,
    Button,
    TextField,
    Checkbox,
    FormControlLabel,
    Card,
    CardContent,
    CardMedia,
    useMediaQuery,
    useTheme,
    CardActionArea,
    Snackbar,
    SnackbarContent,
    IconButton,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { Phone, Email, Close } from "@mui/icons-material";
import { useParams, useLocation, useNavigate } from "react-router-dom";
// import blog_conversation from "../../../ui-assets/blog_conversation.svg";
// import { httpRequest } from "../../../ui-utils/api";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import axios from "axios";
import { backendHosts,apiUrl } from "../../../ui-utils/apiConfig";

function slugify(title) {
    return title
        .toLowerCase()
        .replace(/[^\w\s-]/g, "") // Remove special characters
        .replace(/\s+/g, "-") // Replace spaces with hyphens
        .replace(/-+/g, "-"); // Replace multiple hyphens with a single hyphen
}

const snackeror = {
    myerror: {
        backgroundColor: "#ffffff",
        borderLeft: "8px solid #b60000",
        flexWrap: "nowrap",
        color: "#005100",
        borderTop: "1px solid #b60000",
        borderRight: "1px solid #b60000",
        borderBottom: "1px solid #b60000",
    },
    mysucc: {
        backgroundColor: "#ffffff",
        borderLeft: "8px solid #8db600",
        flexWrap: "nowrap",
        color: "#005100",
        borderTop: "1px solid #8db600",
        borderRight: "1px solid #8db600",
        borderBottom: "1px solid #8db600",
    },
};

const MoreBlogs = () => {
    const { blogId } = useParams();
    const [blogs, setBlogs] = useState([]);
    const [formData, setFormData] = useState({
        email: "",
        message: "",
        terms: false,
    });
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const history = useNavigate();
    const isSmallScreen = useMediaQuery("(max-width:680px)");
    const isMediumScreen = useMediaQuery("(max-width:900px)");
    const scrollRef = useRef(null);
    const isTab = useMediaQuery("(max-width:1200px)");
    const isLaptop = useMediaQuery("(max-width:1380px)");

    const handleCardClick = (blog) => {
        const slug = slugify(blog.blog_title);
        history(`/learn-research/blogs/${blog.id}-${slug}`);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        const fetchBlogs = async () => {
            try {

                const response = await axios.get(`${backendHosts.ADMIN}${apiUrl.getAllBlogs}`)
                // const response = await httpRequest({
                //     endPoint: "api/blogs",
                //     method: "get",
                //     instance: "instanceOne",
                // });
                setBlogs(response.data?.data || []);
            } catch (error) {
                console.error("Error fetching blogs", error);
            }
        };

        fetchBlogs();
    }, []);

    const repeatedBlogs = [
        ...blogs.filter((b) => b.id !== Number(blogId)),
        ...blogs.filter((b) => b.id !== Number(blogId)),
    ];

    useEffect(() => {
        const scrollContainer = scrollRef.current;
        if (scrollContainer) {
            let scrollInterval;

            const startScrolling = () => {
                scrollInterval = setInterval(() => {
                    scrollContainer.scrollLeft += 1;
                    if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
                        scrollContainer.scrollLeft = 0;
                    }
                }, 20); // decrease the interval to fasten the scroll speed
            };

            const stopScrolling = () => {
                clearInterval(scrollInterval);
            };

            scrollContainer.addEventListener("mouseenter", stopScrolling);
            scrollContainer.addEventListener("mouseleave", startScrolling);

            startScrolling();

            return () => {
                stopScrolling();
                scrollContainer.removeEventListener("mouseenter", stopScrolling);
                scrollContainer.removeEventListener("mouseleave", startScrolling);
            };
        }
    }, [blogs, blogId]);

    const handleChange = (e) => {
        const { name, value, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: name === "terms" ? checked : value,
        }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     console.log("Form Data", formData);

    //     try {
    //         const response = await httpRequest({
    //             endPoint: "/api/user_form/blogsubmit",
    //             method: "post",
    //             instance: "instanceOne",
    //             requestBody: formData,
    //         });

    //         if (response.status === 200) {
    //             console.log("Form submitted successfully", response.message);
    //             setFormData({
    //                 email: "",
    //                 message: "",
    //                 terms: false,
    //             });
    //             setSnackbar({
    //                 open: true,
    //                 message: "Form submitted successfully!",
    //                 severity: "success",
    //             });
    //         }
    //     } catch (error) {
    //         console.error("Error:", error);
    //         setSnackbar({
    //             open: true,
    //             message: "Error submitting form. Please try again.",
    //             severity: "error",
    //         });
    //     }
    // };

    const handleCloseSnackbar = () => {
        setSnackbar({
            open: false,
            message: "",
            severity: "success",
        });
    };

    return (
        <>
            {/* More for you to read section */}
            <Box
                sx={{
                    mt: 2,
                    pt: 2,
                    pb: 1,
                    mb:2,
                    backgroundColor: "#ffffff",

                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: "Outfit600",
                        marginBottom: "15px",
                        color: "#000000",
                        fontSize:"calc(30px + var(--font-delta))",
                        lineHeight:"100%",
                        ml:3

                    }}
                >
                    More for you to read
                </Typography>


                <Grid2
                    ref={scrollRef}
                    sx={{
                        display: "flex",
                        flexWrap: "nowrap",
                        overflowX: "auto",
                        position: "relative",
                        gap: 2,
                        py: 2,
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        background:"#ffffff",
                        "&::-webkit-scrollbar": {
                            display: "none",
                        },
                        transition: "transform 0.2s ease-out",

                    }}
                >
                    {repeatedBlogs.map((blog) => {
                        const thumbnail = isSmallScreen
                            ? blog.blog_thumbnail_small_screen
                            : blog.blog_thumbnail_big_screen;

                        return (
                            <Grid2
                                item
                                key={blog.id}
                                sx={{
                                    flexShrink: 0,
                                    px: { xs: 1, sm: 2 },
                                    py: 1,
                                }}
                            >
                                <Card
                                    sx={{
                                        width: isSmallScreen || isMediumScreen ? "320px" : "520px",
                                        // height: "100%",
                                        backgroundColor: "#FFFFFF",
                                        borderRadius: "16px",
                                        transition: "transform 0.3s",
                                        "&:hover": {
                                            transform: "translateY(-5px)",
                                        },
                                        color: "#011126",
                                        display: "flex",
                                        flexDirection: "column",
                                        boxShadow: " 0px 4px 22px 0px #00000040"

                                    }}
                                >
                                    <CardActionArea
                                        onClick={() => handleCardClick(blog)}
                                        sx={{
                                            flexGrow: 1,
                                            display: "flex",
                                            flexDirection: "column",

                                        }}
                                    >
                                        <CardMedia
                                            component="img"
                                            image={thumbnail}
                                            alt={blog.blog_title}
                                            sx={{
                                                // aspectRatio: "16/9",

                                                objectFit: "cover",
                                            }}
                                        />
                                        <CardContent
                                            sx={{
                                                flex: 1,
                                                display: "flex",
                                                flexDirection: "column",
                                                // justifyContent: "space-between",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <Box>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: "8px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    {blog.blog_tags?.slice(0, 2).map((tag, index) => (
                                                        <Typography
                                                            key={index}
                                                            sx={{
                                                                fontFamily: "Inter600",
                                                                color: "#011126 !important",
                                                                fontSize: "calc(12px + var(--font-delta))",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            • {tag}
                                                        </Typography>
                                                    ))}
                                                </Box>
                                                <Typography
                                                    sx={{
                                                        fontWeight: "bold",
                                                        fontSize: { xs: "calc(18px + var(--font-delta))", sm: "calc(20px + var(--font-delta))" },
                                                        marginBottom: "10px",
                                                        color: "#011126 !important",
                                                        fontFamily: "Outfit600!important",
                                                        display: "-webkit-box",
                                                        WebkitLineClamp: 2,
                                                        WebkitBoxOrient: "vertical",
                                                        overflow: "hidden",
                                                    }}
                                                >
                                                    {blog.blog_title}
                                                </Typography>
                                                {!isSmallScreen && (
                                                    <Typography
                                                        sx={{
                                                            color: "#011126 !important",
                                                            marginBottom: "15px",
                                                            fontSize: { xs: "calc(14px + var(--font-delta))", sm: "calc(16px + var(--font-delta))" },
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 3,
                                                            WebkitBoxOrient: "vertical",
                                                            overflow: "hidden",
                                                            fontFamily: "Inter400",
                                                        }}
                                                    >
                                                        {blog.blog_description?.substring(0, 100)}...
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Box>
                                                <Button
                                                    onClick={() => handleCardClick(blog)}
                                                    sx={{
                                                        color: "#CB2F3F",
                                                        fontWeight: "bold",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        fontFamily: "Inter500",
                                                        mt: 2,
                                                        fontSize: "calc(14px + var(--font-delta))"
                                                    }}
                                                >
                                                    Read more
                                                    <ArrowForwardIosIcon
                                                        sx={{
                                                            color: "#CB2F3F",
                                                            borderRadius: "40%",
                                                            background: "white",
                                                            height: "15px",
                                                            p: "10px",
                                                            ml: "8px",
                                                            width: "15px",
                                                        }}
                                                    />
                                                </Button>
                                            </Box>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid2>
                        );
                    })}
                </Grid2>
            </Box>

            {/* Let's have a conversation section */}

            {false && (
                <Grid2
                    sx={{
                        marginTop: "40px",
                        alignItems: "center",
                        backgroundColor: "#F5F5F9",
                        padding: { xs: "20px", md: "40px" },
                        justifyContent: "center",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        gap: isLaptop ? 3 : 14,
                    }}
                >
                    {!isTab && (
                        <Grid2 item xs={12} md={5} display="flex" justifyContent="center">
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <img
                                    // src={blog_conversation}
                                    alt=""
                                    style={{
                                        width: isLaptop ? "500px" : "600px",
                                        height: "auto",
                                        borderRadius: "8px",
                                    }}
                                />
                                <Typography
                                    sx={{
                                        color: "#011126 !important",
                                        fontFamily: "cardiuma-M !important",
                                        fontSize: "calc(18px + var(--font-delta))",
                                    }}
                                >
                                    SEBI's registered advisor Bullforce
                                </Typography>
                            </Box>
                        </Grid2>
                    )}

                    <Grid2
                        sx={{
                            pb: 3,
                            width: isTab ? "90vw" : "auto",
                            fontFamily: "cardiuma-M !important",
                        }}
                    >
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: { xs: "calc(16px + var(--font-delta))", sm: "calc(19px + var(--font-delta))", md: "calc(22px + var(--font-delta))" },
                                fontWeight: "bold",
                                marginBottom: "14px",
                                color: "#011126",
                                textAlign: "left",
                                fontFamily: "cardiuma-M !important",
                            }}
                        >
                            Are you in need of expert recommendations?
                        </Typography>
                        <Typography
                            variant="h5"
                            sx={{
                                fontSize: { xs: "calc(32px + var(--font-delta))", sm: "calc(40px + var(--font-delta))", md: "calc(48px + var(--font-delta))" },
                                fontWeight: "bold",
                                marginBottom: "20px",
                                color: "#011126",
                                textAlign: "left",
                                fontFamily: "cardiuma-M !important",
                            }}
                        >
                            Let's have a conversation.
                        </Typography>
                        <Typography
                            sx={{
                                color: "#011126 !important",
                                marginBottom: "30px",
                                fontWeight: "bold",
                                textAlign: "left",
                                fontSize: isSmallScreen ? "14px" : "18px",
                                fontFamily: "cardiuma-M !important",
                            }}
                        >
                            Please fill in the form
                        </Typography>

                        <Box
                            component="form"
                            // onSubmit={handleSubmit}
                            sx={{
                                backgroundColor: "#F5F5F9",
                                fontFamily: "cardiuma-M !important",
                            }}
                        >
                            <Grid2>
                                <Typography
                                    sx={{
                                        fontSize: isSmallScreen ? "12px" : "16px",
                                        color: "#011126 !important",
                                        marginBottom: "5px",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        fontFamily: "cardiuma-M !important",
                                    }}
                                >
                                    Your email address
                                </Typography>
                                <TextField
                                    fullWidth
                                    label="Your email address"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    error={
                                        formData.email !== "" &&
                                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                                    }
                                    helperText={
                                        formData.email !== "" &&
                                            !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) ? (
                                            <span
                                                style={{
                                                    color: "red",
                                                    fontFamily: "cardiuma-M !important",
                                                }}
                                            >
                                                Please enter a valid email address.
                                            </span>
                                        ) : (
                                            " "
                                        )
                                    }
                                    InputLabelProps={{
                                        style: {
                                            fontFamily: "cardiuma-M !important",
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontFamily: "cardiuma-M !important",
                                        },
                                    }}
                                    sx={{
                                        borderRadius: "6px",
                                        fontFamily: "cardiuma-M !important",
                                        marginBottom: "20px",
                                        "& .MuiInputLabel-root": {
                                            color: "#999999",
                                            fontFamily: "cardiuma-M !important",
                                        },
                                        "& .MuiInputLabel-root.Mui-focused": {
                                            color: "#F3D45E",
                                            fontFamily: "cardiuma-M !important",
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            fontFamily: "cardiuma-Regular !important",
                                            "& input, & textarea": {
                                                backgroundColor: "white",
                                                fontFamily: "cardiuma-Regular !important",
                                            },
                                            "& fieldset": { borderColor: "#E1E1EE" },
                                            "&:hover fieldset": { borderColor: "#F3D45E" },
                                            "&.Mui-focused fieldset": { borderColor: "#F3D45E" },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            fontFamily: "cardiuma-M !important",
                                            color:
                                                formData.email !== "" &&
                                                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                                                    ? "red"
                                                    : "#F5F5F9",
                                        },
                                        "&.Mui-focused .MuiFormHelperText-root": {
                                            fontFamily: "cardiuma-M !important",
                                            color:
                                                formData.email !== "" &&
                                                    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                                                    ? "red"
                                                    : "#F3D45E",
                                        },
                                    }}
                                />
                            </Grid2>
                            <Grid2>
                                <Typography
                                    sx={{
                                        fontSize: isSmallScreen ? "12px" : "16px",
                                        color: "#011126 !important",
                                        marginBottom: "10px",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                        fontFamily: "cardiuma-M !important",
                                    }}
                                >
                                    Your message
                                </Typography>
                                <TextField
                                    fullWidth
                                    label="Tell us more - insert a link to your website and describe your project"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                    multiline
                                    rows={4}
                                    inputProps={{ maxLength: 2500 }}
                                    helperText={`${formData.message.length}/2500 characters`}
                                    InputLabelProps={{
                                        style: {
                                            whiteSpace: "normal",
                                            lineHeight: "1.3",
                                            fontFamily: "cardiuma-M !important",
                                        },
                                    }}
                                    FormHelperTextProps={{
                                        style: {
                                            fontFamily: "cardiuma-M !important",
                                        },
                                    }}
                                    sx={{
                                        borderRadius: "6px",
                                        fontFamily: "cardiuma-M !important",
                                        marginBottom: "20px",
                                        "& .MuiInputLabel-root": {
                                            color: "#999999",
                                            whiteSpace: "normal",
                                            fontFamily: "cardiuma-M !important",
                                        },
                                        "& .MuiInputLabel-root.Mui-focused": {
                                            color: "#F3D45E",
                                            fontFamily: "cardiuma-M !important",
                                        },
                                        "& .MuiOutlinedInput-root": {
                                            padding: 0,
                                            backgroundColor: "white",
                                            fontFamily: "cardiuma-regular !important",
                                            "& .MuiOutlinedInput-input": {
                                                padding: "16.5px 14px",
                                                fontFamily: "cardiuma-regular !important",
                                            },
                                            "& fieldset": {
                                                borderColor: "#E1E1EE",
                                            },
                                            "&:hover fieldset": {
                                                borderColor: "#F3D45E",
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "#F3D45E",
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#999999",
                                            fontFamily: "cardiuma-M !important",
                                            ".Mui-focused &": {
                                                color: "#F3D45E",
                                                fontFamily: "cardiuma-M !important",
                                            },
                                        },
                                        "&.Mui-focused .MuiFormHelperText-root": {
                                            color: "#F3D45E",
                                            fontFamily: "cardiuma-M !important",
                                        },
                                    }}
                                />
                            </Grid2>

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="terms"
                                        checked={formData.terms}
                                        onChange={handleChange}
                                        sx={{
                                            color: "#DEDEED",
                                            "&.Mui-checked": { color: "#F3D45E" },
                                        }}
                                    />
                                }
                                label={
                                    <Typography
                                        sx={{
                                            color: "#011126 !important",
                                            fontSize: "15px",
                                            fontFamily: "cardiuma-M !important",
                                        }}
                                    >
                                        I have read and accept{" "}
                                        <span
                                            style={{
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                            }}
                                            onClick={() =>
                                            (window.location.href =
                                                "https://bullforce.co/Privacy_Policy")
                                            }
                                        >
                                            The terms and conditions.
                                        </span>
                                    </Typography>
                                }
                                sx={{ marginBottom: "20px" }}
                            />
                            <Grid2
                                sx={{
                                    width: "100%",
                                    justifyContent: isSmallScreen ? "center" : "start",
                                    display: "flex",
                                }}
                            >
                                <Button
                                    type="submit"
                                    disabled={!formData.terms}
                                    sx={{
                                        maxWidth: isSmallScreen ? "100%" : "137px",
                                        width: "100%",
                                        borderRadius: "50px",
                                        fontFamily: "cardiuma-M !important",
                                        backgroundColor: formData.terms ? "#F3D45E" : "#cccccc",
                                        color: formData.terms ? "#0B1420" : "#666666",
                                        fontWeight: "bold",
                                        padding: "10px 30px",
                                        "&:hover": {
                                            backgroundColor: formData.terms ? "#e6c74d" : "#cccccc",
                                        },
                                    }}
                                >
                                    Send
                                </Button>
                            </Grid2>
                        </Box>
                    </Grid2>
                </Grid2>
            )}

            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
            >
                <SnackbarContent
                    style={
                        snackbar.severity === "success"
                            ? snackeror.mysucc
                            : snackeror.myerror
                    }
                    message={
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center",
                                fontSize: "12px",
                                color: "#333333",
                                fontFamily: "cardiuma-M",
                            }}
                        >
                            {snackbar.message}
                        </span>
                    }
                    action={
                        <React.Fragment>
                            <IconButton
                                size="small"
                                aria-label="close"
                                color="inherit"
                                onClick={handleCloseSnackbar}
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        </React.Fragment>
                    }
                />
            </Snackbar>
        </>
    );
};

export default MoreBlogs;
